import { render, staticRenderFns } from "./BusinessBanner.vue?vue&type=template&id=26847971&scoped=true&"
import script from "./BusinessBanner.vue?vue&type=script&lang=js&"
export * from "./BusinessBanner.vue?vue&type=script&lang=js&"
import style0 from "./BusinessBanner.vue?vue&type=style&index=0&id=26847971&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26847971",
  null
  
)

export default component.exports